/* ═══════════════════════════════════════════════════════
   MI CUENTA — Caracas Merch · embed.js
   Versión para vivir DENTRO de una página de tu tema
   (caracasmerch.com/pages/cuenta y /en/pages/account),
   con el header/menú/cart drawer del tema alrededor —
   nada de esto pinta su propio header, el tema ya lo pone.
 
   Arquitectura: App Proxy de Shopify. Las llamadas van a
   /apps/cuenta/* (same-origin) y Shopify las proxea al backend
   en Netlify con logged_in_customer_id firmado — sin cookies
   propias, sin CORS, sin OAuth propio.
   Requiere en Netlify: SHOPIFY_APP_PROXY_SECRET (ver MIGRACION.md).
   ═══════════════════════════════════════════════════════ */
 
// ── API vía App Proxy de Shopify (same-origin) ───────────
// El portal ya NO le habla a netlify.app directo: Shopify proxea
// caracasmerch.com/apps/cuenta/* hacia las Netlify Functions y
// agrega logged_in_customer_id con firma HMAC. Como todo es
// same-origin, no hay cookies cross-domain ni CORS.
// Mapeo: api('/api/me') → '/apps/cuenta/me' → (proxy) → '/api/me'.
const APP_PROXY_BASE = '/apps/cuenta';
const api = (path) => APP_PROXY_BASE + path.replace(/^\/api/, '');
 
// ── Idioma — se deriva de la URL de Shopify, no de un parámetro ──
// /en/pages/account → inglés; cualquier otra ruta (/pages/cuenta) → español.
// Esto es más confiable en modo embebido: la URL de Shopify YA ES
// la señal de idioma, no hace falta duplicarla con un query param.
const LANG = (() => {
  // El idioma lo manda LA PÁGINA del tema (selector Translate & Adapt):
  // /en/... = inglés; si no, el atributo lang del documento; default es.
  // Sin preferencia guardada en localStorage — era pegajosa: si visitabas
  // /en/ una vez, el portal quedaba en inglés hasta en las páginas en
  // español, ignorando el selector de idioma del sitio.
  if (/^\/en(\/|-|$)/.test(location.pathname)) return 'en';
  const docLang = (document.documentElement.lang || '').toLowerCase();
  return docLang.startsWith('en') ? 'en' : 'es';
})();
 
const T = {
  es: {
    'tab.inicio': 'Inicio', 'tab.pedidos': 'Pedidos', 'tab.recompensas': 'Recompensas',
    'tab.wishlist': 'Wishlist', 'tab.perfil': 'Perfil', 'top.salir': 'Cerrar sesión',
    'hola': '¡Bienvenido de vuelta, {name}!', 'hola_solo': '¡Bienvenido de vuelta!', 'cred.miembro': 'Miembro · Caracas Merch', 'cred.puntos': 'puntos',
    'cred.faltan': 'Te faltan <strong>{n} puntos</strong> para {tier}',
    'cred.max': 'Estás en el nivel máximo. <strong>{tier}.</strong>',
    'cred.pronto': 'Tus puntos aparecerán aquí muy pronto.',
    'eyebrow.pedidos': 'Tus pedidos', 'eyebrow.nivel': 'Tu nivel', 'eyebrow.ganar': 'Cómo ganar puntos',
    'eyebrow.canjear': 'Rewards disponibles', 'eyebrow.historial': 'Historial de puntos',
    'eyebrow.datos': 'Tus datos', 'eyebrow.direccion': 'Dirección', 'eyebrow.social': 'Redes y cumpleaños',
    'eyebrow.wishlist': 'Guardados', 'eyebrow.sugeridos': 'Completa tu wishlist',
    'pedidos.vacio': 'Aún no tienes pedidos.', 'pedidos.explora': 'Explora la tienda →',
    'pedidos.error': 'No pudimos cargar esto. Intenta de nuevo en un momento.',
    'pedidos.subtotal': 'Subtotal', 'pedidos.envio': 'Envío', 'pedidos.impuestos': 'Impuestos',
    'pedidos.enviar_a': 'Enviar a', 'pedidos.seguimiento': 'Seguimiento',
    'perfil.nombre': 'Nombre', 'perfil.apellido': 'Apellido', 'perfil.correo': 'Correo',
    'perfil.guardar': 'Guardar cambios', 'perfil.guardado': 'Cambios guardados.', 'perfil.error': 'No pudimos guardar.',
    'perfil.direccion1': 'Dirección', 'perfil.direccion2': 'Apto / referencia', 'perfil.ciudad': 'Ciudad',
    'perfil.estado': 'Estado / provincia', 'perfil.cp': 'Código postal', 'perfil.pais': 'País',
    'perfil.telefono': 'Teléfono', 'perfil.cumple': 'Cumpleaños', 'perfil.instagram': 'Instagram', 'perfil.tiktok': 'TikTok',
    'earn.primera': 'Primera compra', 'canjear.btn': 'Canjear', 'canjear.ok': '¡Canjeado! Aquí tienes tu código:',
    'canjear.copiar': 'Aplicar', 'canjear.copiado': 'Aplicado ✓', 'canjear.pendiente': 'Solicitud enviada — te contactaremos.',
    'historial.vacio': 'Aún no tienes movimientos de puntos.',
    'login.btn': 'Iniciar sesión', 'login.nota': 'Te enviaremos un código de acceso a tu correo.',
    'login.titulo': 'Entra a tu cuenta',
    'inicio.banner': 'Caracas Passport · Suma puntos con cada compra',
    'earn.intro': 'Cada compra suma puntos según tu nivel: mientras más alto llegues, más rápido acumulas. Canjéalos por descuentos, merch gratis y experiencias.',
    'earn.cumple': 'Agrega tu cumpleaños', 'earn.cumple.hint': 'en Perfil →',
    'earn.programa': 'Tu Caracas Passport acumula puntos con cada compra. Sube de nivel, estampa un nuevo destino y desbloquea descuentos, envío gratis y merch exclusivo.',
    'eyebrow.missions': 'Missions', 'mission.primera': 'Primera compra', 'mission.cumple': 'Agrega tu cumpleaños', 'mission.review': 'Deja una reseña',
    'eyebrow.beneficios': 'Beneficios por nivel', 'ben.actual': 'Tu nivel', 'ben.pts': 'pts', 'ben.learnmore': 'Ver más',
    'eyebrow.codigos': 'Tus códigos disponibles', 'codes.aplicar': 'Aplicar', 'codes.aplicado': 'Aplicado ✓',
    'codes.welcome': 'Bienvenida · 10% OFF',
    'codes.ver_todo': 'Ver todo ({n})', 'codes.ver_menos': 'Ver menos',
    'codes.lifetime_pct': 'Descuento permanente', 'codes.lifetime_ship': 'Envío gratis permanente',
    'perfil.bonus': '¡Guardado! +{n} puntos por tu cumpleaños 🎉',
    'login.redirect': 'Te enviaremos un código de acceso a tu correo. Redirigiendo al inicio de sesión seguro…',
    'wishlist.buscar': 'Busca un producto para guardarlo…', 'wishlist.vacio': 'Tu wishlist está vacía.',
    'inicio.titulo': 'Mi Cuenta',
    'nav.pedidos.d': 'Revisa tus pedidos y su seguimiento',
    'nav.recompensas.d': 'Gana puntos con cada compra',
    'nav.wishlist.d': 'Guarda lo que te gusta',
    'nav.perfil.d': 'Tus datos, dirección y redes',
    dateLocale: 'es-VE',
    status: {
      PAID: ['Pagado', 'ok'], PARTIALLY_PAID: ['Pago parcial', ''], PENDING: ['Pendiente', ''],
      REFUNDED: ['Reembolsado', ''], PARTIALLY_REFUNDED: ['Reembolso parcial', ''],
      AUTHORIZED: ['Autorizado', ''], VOIDED: ['Anulado', ''],
    },
    ostate: {
      processing: ['En proceso', 'proc', '📦 Estamos preparando tu pedido. El procesamiento toma de 1 a 3 días hábiles.'],
      shipped: ['Enviado', 'ship', '🚚 Tu pedido va en camino. El rastreo puede tardar en actualizarse.'],
      refunded: ['Reembolsado', 'refund', ''],
      partial_refund: ['Reembolso parcial', 'refund', ''],
      cancelled: ['Cancelada', 'cancel', ''],
    },
  },
  en: {
    'tab.inicio': 'Home', 'tab.pedidos': 'Orders', 'tab.recompensas': 'Rewards',
    'tab.wishlist': 'Wishlist', 'tab.perfil': 'Profile', 'top.salir': 'Log out',
    'hola': 'Welcome back, {name}!', 'hola_solo': 'Welcome back!', 'cred.miembro': 'Member · Caracas Merch', 'cred.puntos': 'points',
    'cred.faltan': '<strong>{n} points</strong> to reach {tier}',
    'cred.max': "You've reached the top. <strong>{tier}.</strong>",
    'cred.pronto': 'Your points will show up here very soon.',
    'eyebrow.pedidos': 'Your orders', 'eyebrow.nivel': 'Your tier', 'eyebrow.ganar': 'How to earn points',
    'eyebrow.canjear': 'Available rewards', 'eyebrow.historial': 'Points history',
    'eyebrow.datos': 'Your info', 'eyebrow.direccion': 'Address', 'eyebrow.social': 'Social & birthday',
    'eyebrow.wishlist': 'Saved', 'eyebrow.sugeridos': 'Complete your wishlist',
    'pedidos.vacio': 'No orders yet.', 'pedidos.explora': 'Explore the store →',
    'pedidos.error': "We couldn't load this. Try again in a moment.",
    'pedidos.subtotal': 'Subtotal', 'pedidos.envio': 'Shipping', 'pedidos.impuestos': 'Tax',
    'pedidos.enviar_a': 'Shipping to', 'pedidos.seguimiento': 'Tracking',
    'perfil.nombre': 'First name', 'perfil.apellido': 'Last name', 'perfil.correo': 'Email',
    'perfil.guardar': 'Save changes', 'perfil.guardado': 'Changes saved.', 'perfil.error': "We couldn't save.",
    'perfil.direccion1': 'Address', 'perfil.direccion2': 'Apt / notes', 'perfil.ciudad': 'City',
    'perfil.estado': 'State / province', 'perfil.cp': 'ZIP / postal code', 'perfil.pais': 'Country',
    'perfil.telefono': 'Phone', 'perfil.cumple': 'Birthday', 'perfil.instagram': 'Instagram', 'perfil.tiktok': 'TikTok',
    'earn.primera': 'First purchase', 'canjear.btn': 'Redeem', 'canjear.ok': "Redeemed! Here's your code:",
    'canjear.copiar': 'Apply', 'canjear.copiado': 'Applied ✓', 'canjear.pendiente': "Request sent — we'll reach out.",
    'historial.vacio': 'No points activity yet.',
    'login.btn': 'Log in', 'login.nota': "We'll email you an access code.",
    'login.titulo': 'Log in to your account',
    'inicio.banner': 'Caracas Passport · Earn points with every purchase',
    'earn.intro': 'Every order earns points based on your tier: the higher you climb, the faster you stack. Redeem them for discounts, free merch and experiences.',
    'earn.cumple': 'Add your birthday', 'earn.cumple.hint': 'in Profile →',
    'earn.programa': 'Your Caracas Passport earns points with every purchase. Level up, stamp a new destination and unlock discounts, free shipping and exclusive merch.',
    'eyebrow.missions': 'Missions', 'mission.primera': 'First purchase', 'mission.cumple': 'Add your birthday', 'mission.review': 'Leave a review',
    'eyebrow.beneficios': 'Tier benefits', 'ben.actual': 'Your tier', 'ben.pts': 'pts', 'ben.learnmore': 'Learn more',
    'eyebrow.codigos': 'Your available codes', 'codes.aplicar': 'Apply', 'codes.aplicado': 'Applied ✓',
    'codes.welcome': 'Welcome · 10% OFF',
    'codes.ver_todo': 'View all ({n})', 'codes.ver_menos': 'View less',
    'codes.lifetime_pct': 'Lifetime discount', 'codes.lifetime_ship': 'Lifetime free shipping',
    'perfil.bonus': 'Saved! +{n} points for your birthday 🎉',
    'login.redirect': "We'll email you an access code. Redirecting you to secure sign-in…",
    'wishlist.buscar': 'Search for a product to save it…', 'wishlist.vacio': 'Your wishlist is empty.',
    'inicio.titulo': 'My Account',
    'nav.pedidos.d': 'Track and review your orders',
    'nav.recompensas.d': 'Earn points with every purchase',
    'nav.wishlist.d': 'Save what you love',
    'nav.perfil.d': 'Your info, address & socials',
    dateLocale: 'en-US',
    status: {
      PAID: ['Paid', 'ok'], PARTIALLY_PAID: ['Partially paid', ''], PENDING: ['Pending', ''],
      REFUNDED: ['Refunded', ''], PARTIALLY_REFUNDED: ['Partially refunded', ''],
      AUTHORIZED: ['Authorized', ''], VOIDED: ['Voided', ''],
    },
    ostate: {
      processing: ['Processing', 'proc', '📦 We are preparing your order. Processing takes 1 to 3 business days.'],
      shipped: ['Shipped', 'ship', '🚚 Your order is on the way. Tracking can take some time to update.'],
      refunded: ['Refunded', 'refund', ''],
      partial_refund: ['Partially refunded', 'refund', ''],
      cancelled: ['Cancelled', 'cancel', ''],
    },
  },
};
 
function t(key, vars = {}) {
  let s = T[LANG][key] ?? T.es[key] ?? key;
  for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, v);
  return s;
}
 
const $ = (sel, root = document) => root.querySelector(sel);
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const money = (amount, currency) => {
  if (amount === null || amount === undefined) return '—';
  return new Intl.NumberFormat(t('dateLocale'), { style: 'currency', currency: currency || 'USD' }).format(Number(amount));
};
const fecha = (iso) => new Date(iso).toLocaleDateString(t('dateLocale'), { day: 'numeric', month: 'long', year: 'numeric' });
const debounce = (fn, ms) => { let h; return (...a) => { clearTimeout(h); h = setTimeout(() => fn(...a), ms); }; };
 
// Same-origin vía App Proxy — ya no hace falta credentials:'include'
// ni el flujo OAuth propio. Los 401 se distinguen por tipo:
//   not_logged_in → cliente sin sesión en la tienda → al login nativo.
//   unauthorized  → firma/secret mal configurado → se MUESTRA el error
//     (redirigir aquí crearía un rebote confuso al new customer account).
const LOGIN_URL = `/customer_authentication/login?return_to=${encodeURIComponent(location.pathname)}`;
 
// Pantalla de login embebida — reemplaza el redirect inmediato:
// el visitante deslogueado ve el portal invitándolo a entrar (con
// la marca), en vez de un flash de UI vacía + rebote a Shopify.
let rootEl = null;
function renderLogin() {
  if (!rootEl) { location.href = LOGIN_URL; return; }
  // Bloque en página (queda como respaldo si cierran el modal).
  rootEl.innerHTML = `
    <div class="cm-login cm-in">
      <h1 class="cm-hola">${t('login.titulo')}</h1>
      <p class="cm-login__nota">${t('login.nota')}</p>
      <a class="cm-btn cm-login__btn" href="${LOGIN_URL}">${t('login.btn')}</a>
    </div>`;
 
  // Modal con redirección automática al login de Shopify.
  // La persona puede cerrarlo (X o click afuera) y eso CANCELA la
  // redirección — se queda en la página con el botón de respaldo.
  const overlay = document.createElement('div');
  overlay.className = 'cm-login-modal';
  overlay.innerHTML = `
    <div class="cm-login-modal__card">
      <button class="cm-login-modal__close" type="button" aria-label="&times;">&times;</button>
      <h2 class="cm-login-modal__t">${t('login.btn')}</h2>
      <p class="cm-login-modal__d">${t('login.redirect')}</p>
      <div class="cm-login-modal__spinner" aria-hidden="true"></div>
    </div>`;
  document.body.appendChild(overlay);
 
  const timer = setTimeout(() => { location.href = LOGIN_URL; }, 1800);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay || e.target.closest('.cm-login-modal__close')) {
      clearTimeout(timer);
      overlay.remove();
    }
  });
}
 
const handle401 = async (r) => {
  const body = await r.json().catch(() => ({}));
  if (body.error === 'not_logged_in') { renderLogin(); return null; }
  throw new Error(body.detail || body.error || 'Error 401');
};
const jget = (path) => fetch(api(path)).then(async (r) => {
  if (r.status === 401) return handle401(r);
  const body = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(body.detail || body.error || `Error ${r.status}`);
  return body;
});
const jpost = (path, data) => fetch(api(path), {
  method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(data),
}).then(async (r) => {
  if (r.status === 401) return handle401(r);
  const body = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(body.detail || body.error || `Error ${r.status}`);
  bustMe(); // cualquier escritura (canje, perfil, wishlist) invalida el caché de /api/me
  return body;
});
 
// ── Caché de /api/me (stale-while-revalidate) ────────────
// /api/me es la llamada más pesada y CADA tab la necesita. Se
// cachea en sessionStorage: las visitas siguientes pintan al
// instante desde el caché mientras se revalida en background.
// Se invalida en cualquier POST exitoso y al hacer logout.
const ME_CACHE_KEY = 'cm_me_v1';
let meRevalidating = false;
 
function bustMe() { try { sessionStorage.removeItem(ME_CACHE_KEY); } catch (_) {} }
 
async function fetchMeFresh() {
  const me = await jget('/api/me');
  if (me) { try { sessionStorage.setItem(ME_CACHE_KEY, JSON.stringify(me)); } catch (_) {} }
  return me;
}
 
async function getMe() {
  let cached = null;
  try { cached = JSON.parse(sessionStorage.getItem(ME_CACHE_KEY) || 'null'); } catch (_) {}
  if (cached) {
    if (!meRevalidating) {
      meRevalidating = true;
      fetchMeFresh().catch(() => {}).finally(() => { meRevalidating = false; });
    }
    return cached;
  }
  return fetchMeFresh();
}
 
function errorBox(err) {
  return `<div class="cm-embed-empty">${t('pedidos.error')}<br><small style="opacity:.6">${esc(String(err?.message || err))}</small></div>`;
}
 
function applyTier(tierIndex) {
  for (let i = 1; i <= 6; i++) document.body.classList.remove(`cm-tier-${i}`);
  document.body.classList.add(`cm-tier-${tierIndex || 1}`);
}
 
function credHtml(me) {
  const loyalty = me.loyalty;
  const points = loyalty?.points ?? null;
  const tierData = me.rewardsProgram?.tiers?.find(t => t.name === loyalty?.tier) || me.rewardsProgram?.tiers?.[0];
  const bgImage  = tierData?.image    || '';
  const subtitle = (LANG === 'en' ? tierData?.subtitle_en : tierData?.subtitle) || tierData?.subtitle || t('cred.miembro');
  let nextLine = '';
  if (points !== null) nextLine = loyalty.nextTier ? t('cred.faltan', { n: loyalty.pointsToNext, tier: esc(loyalty.nextTier) }) : t('cred.max').replace('{tier}', esc(loyalty?.tier || ''));
  return `
    <div class="cm-cred cm-in${bgImage ? ' cm-cred--photo' : ''}" ${bgImage ? `style="background-image:url('${esc(bgImage)}')"` : ''}>
      <div class="cm-cred__row">
        <div>
          <div class="cm-cred__label">${esc(subtitle)}</div>
          <h2 class="cm-cred__tier">${esc(loyalty?.tier || 'La Guaira')}</h2>
          ${points !== null ? `<div class="cm-cred__chip">${esc(loyalty.tier)} · ${loyalty.multiplier}x ${t('cred.puntos')}/$</div>` : ''}
        </div>
        ${points !== null ? `<div class="cm-cred__points"><div class="cm-cred__points-n">${points}</div><div class="cm-cred__points-l">${t('cred.puntos')}</div></div>` : ''}
      </div>
      ${points !== null
        ? `<div class="cm-cred__track"><div class="cm-cred__fill" id="credFill" style="width:0%"><span class="cm-cred__dot"></span></div></div><p class="cm-cred__next">${nextLine}</p>`
        : `<p class="cm-cred__next">${t('cred.pronto')}</p>`}
    </div>`;
}
 
function animateCred(me) {
  const fill = $('#credFill');
  if (!fill) return;
  const pct = me.loyalty?.progressPct ?? 0;
  requestAnimationFrame(() => requestAnimationFrame(() => { fill.style.width = `${pct}%`; }));
}
 
// ── Paneles ──────────────────────────────────────────────
// Accesos rápidos del Home — títulos reutilizan las etiquetas de
// los tabs; las descripciones viven en el diccionario (bilingüe).
function quicknavHtml() {
  const cards = ['pedidos', 'recompensas', 'wishlist', 'perfil'];
  return `
    <div class="cm-quicknav cm-in">
      ${cards.map((k) => `
        <a class="cm-qcard" href="#${k}">
          <span class="cm-qcard__t">${t(`tab.${k}`)}</span>
          <span class="cm-qcard__d">${t(`nav.${k}.d`)}</span>
        </a>`).join('')}
    </div>`;
}
 
async function renderInicio(panel) {
  panel.innerHTML = '<div class="cm-skel" style="height:140px"></div>';
  try {
    const me = await getMe();
    if (!me) return;
    applyTier(me.loyalty?.tierIndex);
    panel.innerHTML = `
      <h1 class="cm-hola cm-in">${esc(me.customer.firstName ? t('hola', { name: me.customer.firstName }) : t('hola_solo'))}</h1>
      <a class="cm-newbadge cm-in" href="#recompensas">${t('inicio.banner')}</a>
      ${credHtml(me)}
      <div id="cmCodesHome"></div>
      ${quicknavHtml()}
      <div class="cm-inicio-salir cm-in">
        <a class="cm-btn cm-btn--ghost" href="/account/logout">${t('top.salir')}</a>
      </div>`;
    animateCred(me);
    loadCodesInto('cmCodesHome', me.rewardsProgram?.catalog);
  } catch (err) { panel.innerHTML = errorBox(err); }
}
 
// Estado del pedido para el cliente, en orden de prioridad:
// cancelada > reembolsada > enviada (fulfillment o tracking) > en proceso.
function orderState(o) {
  if (o.cancelledAt || o.financialStatus === 'VOIDED') return 'cancelled';
  if (o.financialStatus === 'REFUNDED') return 'refunded';
  if (o.financialStatus === 'PARTIALLY_REFUNDED') return 'partial_refund';
  const f = o.fulfillmentStatus || '';
  if (f === 'FULFILLED' || f === 'PARTIALLY_FULFILLED' || (o.tracking && o.tracking.length)) return 'shipped';
  return 'processing';
}
 
function orderCardHtml(o, idx) {
  const [label, tone, aviso] = T[LANG].ostate[orderState(o)];
  const thumbs = o.items.filter((i) => i.image).slice(0, 6).map((i) => `<img src="${esc(i.image)}" alt="${esc(i.alt)}" loading="lazy">`).join('');
  const lines = o.items.map((li) => `
    <div class="cm-order__line">
      ${li.image ? `<img src="${esc(li.image)}" alt="${esc(li.alt)}" loading="lazy">` : ''}
      <div><div class="cm-order__line-t">${esc(li.name)}</div><div class="cm-order__line-v">${li.variant ? esc(li.variant) + ' · ' : ''}×${li.quantity}</div></div>
      <div class="cm-order__line-p">${money(li.price?.amount, li.price?.currencyCode)}</div>
    </div>`).join('');
  const addr = o.shippingAddress;
  const addrHtml = addr ? `<div class="cm-order__addr"><strong>${t('pedidos.enviar_a')}</strong>${esc(addr.address1)}${addr.address2 ? ', ' + esc(addr.address2) : ''}<br>${esc(addr.city)}, ${esc(addr.province)} ${esc(addr.zip)}<br>${esc(addr.country)}</div>` : '';
  const trackHtml = o.tracking?.length ? `<div class="cm-order__track"><strong>${t('pedidos.seguimiento')}:</strong> ${o.tracking.map((tr) => tr.url ? `<a href="${esc(tr.url)}" target="_blank" rel="noopener">${esc(tr.company || tr.number)}</a>` : esc(tr.number)).join(' · ')}</div>` : '';
  return `
    <article class="cm-order cm-in" id="cmOrder${idx}">
      <button class="cm-order__summary" type="button" data-toggle="cmOrder${idx}">
        <div class="cm-order__head"><span class="cm-order__name">${esc(o.name)}</span><span class="cm-order__date">${fecha(o.processedAt)}</span></div>
        ${thumbs ? `<div class="cm-thumbs">${thumbs}</div>` : ''}
        <div class="cm-order__foot"><span class="cm-chip cm-chip--state cm-chip--${tone}">${esc(label)}</span><span><span class="cm-order__total">${money(o.total?.amount, o.total?.currencyCode)}</span><span class="cm-order__caret">▾</span></span></div>
      </button>
      <div class="cm-order__detail">
        ${aviso ? `<div class="cm-order__notice cm-order__notice--${tone}">${aviso}</div>` : ''}
        ${lines}
        <div class="cm-order__totals"><div><span>${t('pedidos.subtotal')}</span><span>${money(o.subtotal?.amount, o.subtotal?.currencyCode)}</span></div><div><span>${t('pedidos.envio')}</span><span>${money(o.shipping?.amount, o.shipping?.currencyCode)}</span></div><div><span>${t('pedidos.impuestos')}</span><span>${money(o.tax?.amount, o.tax?.currencyCode)}</span></div></div>
        ${addrHtml}${trackHtml}
      </div>
    </article>`;
}
 
async function renderPedidos(panel) {
  panel.innerHTML = `<p class="cm-eyebrow">${t('eyebrow.pedidos')}</p><div class="cm-skel" style="height:120px"></div>`;
  try {
    const me = await getMe();
    if (!me) return;
    applyTier(me.loyalty?.tierIndex);
    const { orders } = await jget('/api/orders');
    const box = document.createElement('div');
    if (!orders.length) {
      box.innerHTML = `<div class="cm-empty">${t('pedidos.vacio')}<br><a href="/">${t('pedidos.explora')}</a></div>`;
    } else {
      box.innerHTML = orders.map(orderCardHtml).join('');
      box.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-toggle]');
        if (!btn) return;
        document.getElementById(btn.dataset.toggle)?.classList.toggle('is-open');
      });
    }
    panel.innerHTML = `<p class="cm-eyebrow">${t('eyebrow.pedidos')}</p>`;
    panel.appendChild(box);
  } catch (err) { panel.innerHTML = errorBox(err); }
}
 
// ── Traducción del historial de puntos ───────────────────
// Las razones se GUARDAN en español al momento del evento (son
// un log, no claves traducibles). Para la vista en inglés se
// traducen al render: los patrones son finitos (los genera
// nuestro propio backend) y los nombres de rewards se mapean
// es→en con el catálogo bilingüe que ya trae /api/me.
const LEGACY_REWARD_EN = {
  'Video con el founder': 'Video call with the founder',
  'Free Tee': 'Free Tee',
};
 
function reasonEn(reason, catalog) {
  if (LANG !== 'en' || !reason) return reason;
  let s = reason;
  s = s.replace('Puntos por tus compras anteriores', 'Points for your past purchases');
  s = s.replace('Canje solicitado:', 'Redeem requested:');
  s = s.replace('Canje:', 'Redeemed:');
  s = s.replace('(pendiente)', '(pending)');
  s = s.replace(/^Compra #/, 'Purchase #');
  s = s.replace('Bono cumpleaños', 'Birthday bonus');
  s = s.replace('Bono primera compra', 'First purchase bonus');
  for (const rw of catalog || []) {
    if (rw.label?.es && rw.label?.en && rw.label.es !== rw.label.en) s = s.replace(rw.label.es, rw.label.en);
  }
  for (const [es, en] of Object.entries(LEGACY_REWARD_EN)) s = s.replace(es, en);
  return s;
}
 
// ── Códigos disponibles (compartido: Home y Recompensas) ──
// Verifica en Shopify cuáles siguen activos y sin usar; el botón
// Aplicar usa el endpoint nativo /discount/CODE de la tienda, que
// deja el descuento listo en el checkout de la sesión actual.
async function applyDiscount(code, btn) {
  if (!btn || btn.disabled) return;
  btn.disabled = true;
  try { await fetch(`/discount/${encodeURIComponent(code)}`, { redirect: 'manual' }); } catch (_) {}
  try { navigator.clipboard.writeText(code); } catch (_) {}
  const prev = btn.textContent;
  btn.textContent = t('codes.aplicado');
  btn.classList.add('is-applied');
  setTimeout(() => { btn.textContent = prev; btn.classList.remove('is-applied'); btn.disabled = false; }, 2600);
}
 
function loadCodesInto(containerId, catalog) {
  const VISIBLE = 3; // cuántos se muestran por defecto
  (async () => {
    try {
      const r = await jget('/api/codes');
      const el = document.getElementById(containerId);
      if (!r || !r.codes || !r.codes.length || !el) return;
      const descFor = (code) => {
        const map = LANG === 'en'
          ? { 'CM-OFF15': '15% OFF your order', 'CM-OFF20': '20% OFF your order', 'CM-FREESHIP': 'Free shipping on your order', 'CM-FREETEE': 'One free tee', 'CM-FREEHOODIE': 'One free hoodie', 'CM-FREEBANDANA': 'One free bandana' }
          : { 'CM-OFF15': '15% OFF en tu pedido', 'CM-OFF20': '20% OFF en tu pedido', 'CM-FREESHIP': 'Envío gratis en tu pedido', 'CM-FREETEE': 'Una camiseta gratis', 'CM-FREEHOODIE': 'Un hoodie gratis', 'CM-FREEBANDANA': 'Una bandana gratis' };
        const key = Object.keys(map).find((k) => code.startsWith(k));
        return key ? map[key] : '';
      };
      // Auto-aplicar códigos lifetime en background (sin que el usuario haga nada)
      const lifetimeCodes = r.codes.filter(c => c.kind === 'lifetime_pct' || c.kind === 'lifetime_ship');
      for (const lc of lifetimeCodes) {
        fetch(`/discount/${encodeURIComponent(lc.code)}`, { redirect: 'manual' }).catch(() => {});
      }
 
      const codeLabel = (c) => {
        if (c.kind === 'lifetime_pct')  return t('codes.lifetime_pct');
        if (c.kind === 'lifetime_ship') return t('codes.lifetime_ship');
        if (c.kind === 'welcome')       return t('codes.welcome');
        return esc(descFor(c.code) || reasonEn(c.label, catalog));
      };
 
      const rowHtml = (c) => `
        <div class="cm-code-row${c.kind === 'lifetime_pct' || c.kind === 'lifetime_ship' ? ' cm-code-row--lifetime' : ''}">
          <div>
            <div class="cm-code-row__c">${esc(c.code)}</div>
            <div class="cm-code-row__l">${codeLabel(c)}</div>
          </div>
          <button type="button" class="cm-code-copy" data-code="${esc(c.code)}">${t('codes.aplicar')}</button>
        </div>`;
      const all = r.codes;
      const visible = all.slice(0, VISIBLE);
      const hidden = all.slice(VISIBLE);
      const hasMore = hidden.length > 0;
      el.innerHTML = `
        <p class="cm-eyebrow">${t('eyebrow.codigos')}</p>
        <div class="cm-card cm-in cm-codes">
          ${visible.map(rowHtml).join('')}
          ${hasMore ? `<div class="cm-codes-extra" style="display:none">${hidden.map(rowHtml).join('')}</div>
          <button type="button" class="cm-codes-toggle">${t('codes.ver_todo').replace('{n}', all.length)}</button>` : ''}
        </div>`;
      el.addEventListener('click', (ev) => {
        const b = ev.target.closest('.cm-code-copy');
        if (b) { applyDiscount(b.dataset.code, b); return; }
        const tog = ev.target.closest('.cm-codes-toggle');
        if (tog) {
          const extra = el.querySelector('.cm-codes-extra');
          const open = extra.style.display !== 'none';
          extra.style.display = open ? 'none' : '';
          tog.textContent = open
            ? t('codes.ver_todo').replace('{n}', all.length)
            : t('codes.ver_menos');
        }
      });
    } catch (_) {}
  })();
}
 
// Acordeón de beneficios: una tarjeta por nivel, con el fondo
// metalizado de cada tier, en scroll horizontal. No acumulativos.
function benefitsHtml(prog, loyalty) {
  const tiers = prog.tiers || [];
  const bens = prog.benefits || [];
  const current = loyalty?.tierIndex || 1;
  const cards = tiers.map((tr, i) => {
    const next = tiers[i + 1];
    const range = LANG === 'en'
      ? (next ? `${tr.min} to ${next.min} ${t('ben.pts')}` : `${tr.min}+ ${t('ben.pts')}`)
      : (next ? `${tr.min} a ${next.min} ${t('ben.pts')}` : `${tr.min}+ ${t('ben.pts')}`);
    const items = (bens[i]?.[LANG] || bens[i]?.es || []).map((b) => `<li>${esc(b)}</li>`).join('');
    const subtitle = (LANG === 'en' ? tr.subtitle_en : tr.subtitle) || tr.subtitle || '';
    const bgImage = tr.image || '';
    const photoClass = bgImage ? ' cm-tiercard--photo' : '';
    const bgStyle = bgImage ? ` style="background-image:url('${esc(bgImage)}')"` : '';
    return `
      <div class="cm-tiercard cm-tiercard--${i + 1}${photoClass} ${i + 1 === current ? 'is-current' : ''}"${bgStyle}>
        <div class="cm-tiercard__header">
          <div class="cm-tiercard__name">${esc(tr.name)}</div>
          ${i + 1 === current ? `<span class="cm-tiercard__now">${t('ben.actual')}</span>` : ''}
        </div>
        ${subtitle ? `<div class="cm-tiercard__subtitle">${esc(subtitle)}</div>` : ''}
        <div class="cm-tiercard__range">${range} · ${tr.multiplier}x</div>
        <ul class="cm-tiercard__list">${items}</ul>
      </div>`;
  }).join('');
  return `
    <details class="cm-acc cm-in">
      <summary class="cm-acc__head cm-acc__head--btn">${t('eyebrow.beneficios')}<span class="cm-acc__learn">${t('ben.learnmore')}</span></summary>
      <div class="cm-tiers-scroll">${cards}</div>
    </details>`;
}
 
async function renderRecompensas(panel) {
  panel.innerHTML = `<p class="cm-eyebrow">${t('eyebrow.nivel')}</p><div class="cm-skel" style="height:96px"></div>`;
  try {
    const me = await getMe();
    if (!me) return;
    applyTier(me.loyalty?.tierIndex);
    const prog = me.rewardsProgram;
    let loyalty = me.loyalty;
 
    // Missions
    const hist = loyalty?.history || [];
    const mDone = {
      primera: hist.some(e => e.source === 'first_purchase' || e.description === 'Bono primera compra'),
      cumple:  !!(me.profile?.birthday),
      review:  hist.some(e => e.source === 'judgeme_review'),
    };
    const mkMission = (key, icon, pts, href) => {
      const done = mDone[key];
      const tag  = href ? 'a' : 'div';
      const attr = href && !done ? ` href="${href}"` : '';
      return `<${tag} class="cm-mission${done ? ' cm-mission--done' : ''}"${attr}>
        <span class="cm-mission__icon">${icon}</span>
        <span class="cm-mission__label">${t('mission.' + key)}</span>
        <span class="cm-mission__v">${done ? '✓' : '+' + pts}</span>
      </${tag}>`;
    };
    const missionsHtml =
      mkMission('primera', '🛍️', prog.firstOrderBonus || 50) +
      mkMission('cumple',  '🎂', prog.birthdayBonus   || 25, '#perfil') +
      mkMission('review',  '⭐', 50);
 
    // ── Earn section ──────────────────────────────────────
    const earnSectionHtml = `
      <p class="cm-eyebrow">${t('eyebrow.ganar')}</p>
      <div class="cm-earn-card cm-in">
        <span class="cm-earn-card__tag">Caracas Merch Club</span>
        <p class="cm-earn-tagline">${t('earn.programa')}</p>
      </div>`;
 
    function catalogHtml() {
      const points = loyalty?.points ?? 0;
      return prog.catalog.map((r) => {
        const label = r.label[LANG] || r.label.es;
        const canAfford = points >= r.cost && !r.locked;
        return `<div class="cm-reward cm-in ${r.locked ? 'cm-reward--locked' : ''}">
          <div class="cm-reward__cost">${r.cost}</div><div class="cm-reward__label">${esc(label)}</div>
          ${r.locked ? `<span class="cm-reward__lock">🔒</span>` : `<button class="cm-reward__btn" data-redeem="${esc(r.id)}" ${canAfford ? '' : 'disabled'}>${t('canjear.btn')}</button>`}
        </div>`;
      }).join('');
    }
 
    function ledgerHtml(entries) {
      if (!entries?.length) return `<p style="font-size:13px;color:var(--cm-humo)">${t('historial.vacio')}</p>`;
      return entries.map((e) => {
        const hasDelta = typeof e.delta === 'number';
        const cls = hasDelta ? (e.delta >= 0 ? 'is-pos' : 'is-neg') : '';
        const label = hasDelta ? `${e.delta >= 0 ? '+' : ''}${e.delta}` : '';
        return `<div class="cm-ledger-row"><div><div class="cm-ledger-row__r">${esc(reasonEn(e.reason, prog.catalog))}</div><div class="cm-ledger-row__d">${fecha(e.date)}</div></div><div class="cm-ledger-row__v ${cls}">${label}</div></div>`;
      }).join('');
    }
 
    panel.innerHTML = `
      <p class="cm-eyebrow">${t('eyebrow.nivel')}</p>
      ${credHtml(me)}
      ${benefitsHtml(prog, loyalty)}
      ${earnSectionHtml}
      <p class="cm-eyebrow">${t('eyebrow.missions')}</p>
      <div class="cm-missions cm-in">${missionsHtml}</div>
      <div id="cmCodes"></div>
      <p class="cm-eyebrow">${t('eyebrow.canjear')}</p>
      <div class="cm-toast" id="cmRToast"></div>
      <div id="cmCatalog">${catalogHtml()}</div>
      <details class="cm-acc cm-in">
        <summary class="cm-acc__head">${t('eyebrow.historial')}<span class="cm-acc__chev" aria-hidden="true">›</span></summary>
        <div class="cm-card" id="cmLedger">${ledgerHtml(loyalty?.history)}</div>
      </details>`;
    animateCred(me);
    loadCodesInto('cmCodes', prog.catalog);
 
    $('#cmCatalog').addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-redeem]');
      if (!btn) return;
      btn.disabled = true;
      const original = btn.textContent;
      btn.textContent = '…';
      try {
        const body = await jpost('/api/rewards/redeem', { rewardId: btn.dataset.redeem });
        loyalty = body.loyalty;
        $('#cmLedger').innerHTML = ledgerHtml(body.loyalty.history);
        const toast = $('#cmRToast');
        toast.className = 'cm-toast is-ok';
        if (body.code) {
          toast.innerHTML = `<button class="cm-toast__close" type="button" aria-label="Cerrar">×</button><div>${t('canjear.ok')}</div><div class="cm-reward__code-row"><code class="cm-reward__code">${esc(body.code)}</code><button class="cm-reward__copy" type="button" data-copy="${esc(body.code)}">${t('canjear.copiar')}</button></div>`;
        } else {
          toast.textContent = t('canjear.pendiente');
          setTimeout(() => { toast.className = 'cm-toast'; }, 8000);
        }
        $('#cmCatalog').innerHTML = catalogHtml();
        loadCodesInto('cmCodes', prog.catalog); // el código nuevo aparece de una vez
      } catch (err) {
        const toast = $('#cmRToast');
        toast.className = 'cm-toast is-err';
        toast.textContent = String(err.message || err);
        setTimeout(() => { toast.className = 'cm-toast'; }, 6000);
        btn.disabled = false;
        btn.textContent = original;
      }
    });
 
    $('#cmRToast').addEventListener('click', async (e) => {
      if (e.target.closest('.cm-toast__close')) { $('#cmRToast').className = 'cm-toast'; $('#cmRToast').innerHTML = ''; return; }
      const copyBtn = e.target.closest('[data-copy]');
      if (copyBtn) {
        applyDiscount(copyBtn.dataset.copy, copyBtn);
        return;
      }
    });
  } catch (err) { panel.innerHTML = errorBox(err); }
}
 
async function renderWishlist(panel) {
  panel.innerHTML = `
    <p class="cm-eyebrow">${t('eyebrow.wishlist')}</p>
    <div class="cm-search"><input type="text" id="cmWSearch" placeholder="${esc(t('wishlist.buscar'))}" autocomplete="off"><div class="cm-search__results" id="cmWResults"></div></div>
    <div class="cm-wgrid" id="cmWGrid"><div class="cm-skel" style="height:180px;grid-column:1/-1"></div></div>
    <div id="cmWSuggestWrap"><p class="cm-eyebrow">${t('eyebrow.sugeridos')}</p><div class="cm-wsuggest__items" id="cmWSuggest"></div></div>`;
  try {
    const me = await getMe();
    if (!me) return;
    applyTier(me.loyalty?.tierIndex);
  } catch (err) { panel.innerHTML = errorBox(err); return; }
 
  const input = $('#cmWSearch'), results = $('#cmWResults'), grid = $('#cmWGrid'), suggest = $('#cmWSuggest');
  let savedIds = new Set(), suggestPool = null;
  const VISIBLE = 4;
 
  async function toggleWishlist(productId) {
    try { await jpost('/api/wishlist/toggle', { productId }); return true; }
    catch (err) { console.error(err); return false; }
  }
 
  async function loadGrid() {
    try {
      const { products } = await jget('/api/wishlist');
      savedIds = new Set(products.map((p) => p.id));
      grid.innerHTML = !products.length
        ? `<div class="cm-empty" style="grid-column:1/-1">${t('wishlist.vacio')}</div>`
        : products.map((p) => `
          <div class="cm-wcard cm-in">
            <div class="cm-wcard__media">${p.image ? `<a href="https://caracasmerch.com/products/${esc(p.handle)}" target="_blank" rel="noopener" aria-label="${esc(p.title)}"><img src="${esc(p.image)}" alt="${esc(p.alt)}" loading="lazy"></a>` : ''}<button class="cm-wcard__remove" data-remove="${esc(p.id)}" aria-label="Quitar">×</button></div>
            <div class="cm-wcard__info"><a class="cm-wcard__t" href="https://caracasmerch.com/products/${esc(p.handle)}" target="_blank" rel="noopener">${esc(p.title)}</a><div class="cm-wcard__p">${p.price ? money(p.price.amount, p.price.currencyCode) : ''}</div></div>
          </div>`).join('');
      renderSuggest();
    } catch (err) { grid.innerHTML = errorBox(err); }
  }
 
  function renderSuggest() {
    if (suggestPool === null) return;
    const wrap = $('#cmWSuggestWrap');
    const visible = suggestPool.filter((p) => !savedIds.has(p.id)).slice(0, VISIBLE);
    if (!visible.length) { wrap.style.display = 'none'; return; }
    wrap.style.display = '';
    suggest.innerHTML = visible.map((p) => `
      <div class="cm-wsuggest__card cm-in">
        <div class="cm-wsuggest__media">${p.image ? `<a href="https://caracasmerch.com/products/${esc(p.handle)}" target="_blank" rel="noopener" aria-label="${esc(p.title)}"><img src="${esc(p.image)}" alt="${esc(p.alt)}" loading="lazy"></a>` : ''}<button class="cm-wsuggest__plus" data-suggest="${esc(p.id)}" aria-label="+">+</button></div>
        <a class="cm-wsuggest__name" href="https://caracasmerch.com/products/${esc(p.handle)}" target="_blank" rel="noopener">${esc(p.title)}</a>
        <div class="cm-wsuggest__price">${p.price ? money(p.price.amount, p.price.currencyCode) : ''}</div>
      </div>`).join('');
  }
 
  grid.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-remove]');
    if (!btn) return;
    btn.closest('.cm-wcard').style.opacity = '0.4';
    if (await toggleWishlist(btn.dataset.remove)) loadGrid(); else btn.closest('.cm-wcard').style.opacity = '1';
  });
  suggest.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-suggest]');
    if (!btn) return;
    btn.disabled = true;
    if (await toggleWishlist(btn.dataset.suggest)) loadGrid();
    btn.disabled = false;
  });
 
  const doSearch = debounce(async (q) => {
    if (q.length < 2) { results.classList.remove('is-open'); results.innerHTML = ''; return; }
    const { products } = await jget(`/api/products/search?q=${encodeURIComponent(q)}`);
    if (!products.length) { results.classList.remove('is-open'); results.innerHTML = ''; return; }
    results.innerHTML = products.map((p) => `<button class="cm-search__row" type="button" data-add="${esc(p.id)}">${p.image ? `<img src="${esc(p.image)}" alt="">` : ''}<span class="cm-search__row-t">${esc(p.title)}</span><span class="cm-search__row-p">${p.price ? money(p.price.amount, p.price.currencyCode) : ''}</span></button>`).join('');
    results.classList.add('is-open');
  }, 300);
  input.addEventListener('input', (e) => doSearch(e.target.value.trim()));
  results.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add]');
    if (!btn) return;
    await toggleWishlist(btn.dataset.add);
    input.value = ''; results.classList.remove('is-open'); results.innerHTML = '';
    loadGrid();
  });
 
  loadGrid();
  jget('/api/products/collection?handle=t-shirts&limit=16').then((data) => { suggestPool = data?.products || []; renderSuggest(); }).catch(() => { suggestPool = []; });
}
 
function bdaySelects(birthday) {
  let y = '', m = '', d = '';
  if (birthday && /^\d{4}-\d{2}-\d{2}$/.test(birthday)) { [y, m, d] = birthday.split('-'); }
  const monthNames = LANG === 'en'
    ? ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    : ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
  const mopts = monthNames.map((mn, i) => { const v = String(i + 1).padStart(2, '0'); return `<option value="${v}"${m === v ? ' selected' : ''}>${mn}</option>`; }).join('');
  const dopts = Array.from({ length: 31 }, (_, i) => { const v = String(i + 1).padStart(2, '0'); return `<option value="${v}"${d === v ? ' selected' : ''}>${i + 1}</option>`; }).join('');
  const curY = new Date().getFullYear();
  const yopts = Array.from({ length: 100 }, (_, i) => { const yr = String(curY - i); return `<option value="${yr}"${y === yr ? ' selected' : ''}>${yr}</option>`; }).join('');
  const ph = LANG === 'en' ? ['Month', 'Day', 'Year'] : ['Mes', 'Día', 'Año'];
  return `<select name="bday_m" class="cm-bday-sel"><option value="">${ph[0]}</option>${mopts}</select>`
       + `<select name="bday_d" class="cm-bday-sel"><option value="">${ph[1]}</option>${dopts}</select>`
       + `<select name="bday_y" class="cm-bday-sel"><option value="">${ph[2]}</option>${yopts}</select>`;
}
 
async function renderPerfil(panel) {
  panel.innerHTML = '<div class="cm-skel" style="height:140px"></div>';
  let me;
  try {
    me = await getMe();
    if (!me) return;
    applyTier(me.loyalty?.tierIndex);
  } catch (err) { panel.innerHTML = errorBox(err); return; }
 
  const c = me.customer, p = me.profile || {}, a = c.defaultAddress || {};
 
  panel.innerHTML = `
    <p class="cm-eyebrow">${t('eyebrow.datos')}</p>
    <div class="cm-card cm-in"><form id="cmFDatos">
      <div class="cm-form-2col"><div class="cm-form-row"><label>${t('perfil.nombre')}</label><input name="firstName" value="${esc(c.firstName)}" required></div><div class="cm-form-row"><label>${t('perfil.apellido')}</label><input name="lastName" value="${esc(c.lastName)}"></div></div>
      <div class="cm-field" style="padding-top:0"><div class="cm-field__l">${t('perfil.correo')}</div><div class="cm-field__v">${esc(c.email || '—')}</div></div>
      <button class="cm-btn cm-form-save" type="submit">${t('perfil.guardar')}</button><div class="cm-toast" id="cmTDatos"></div>
    </form></div>
    <p class="cm-eyebrow">${t('eyebrow.direccion')}</p>
    <div class="cm-card cm-in"><form id="cmFDireccion" autocomplete="on">
      <div class="cm-form-row"><label>${t('perfil.direccion1')}</label><input name="address1" autocomplete="address-line1" value="${esc(a.address1)}"></div>
      <div class="cm-form-row"><label>${t('perfil.direccion2')}</label><input name="address2" autocomplete="address-line2" value="${esc(a.address2)}"></div>
      <div class="cm-form-2col"><div class="cm-form-row"><label>${t('perfil.ciudad')}</label><input name="city" autocomplete="address-level2" value="${esc(a.city)}"></div><div class="cm-form-row"><label>${t('perfil.estado')}</label><input name="province" autocomplete="address-level1" value="${esc(a.province)}"></div></div>
      <div class="cm-form-2col"><div class="cm-form-row"><label>${t('perfil.cp')}</label><input name="zip" autocomplete="postal-code" value="${esc(a.zip)}"></div><div class="cm-form-row"><label>${t('perfil.pais')}</label><input name="country" autocomplete="country-name" value="${esc(a.country)}" readonly style="opacity:0.6;cursor:default"></div></div>
      <input type="hidden" name="countryCode" value="${esc(a.countryCode || '')}">
      <div class="cm-form-row"><label>${t('perfil.telefono')}</label><input name="phoneNumber" autocomplete="tel" value="${esc(a.phoneNumber)}"></div>
      <button class="cm-btn cm-form-save" type="submit">${t('perfil.guardar')}</button><div class="cm-toast" id="cmTDireccion"></div>
    </form></div>
    <p class="cm-eyebrow">${t('eyebrow.social')}</p>
    <div class="cm-card cm-in"><form id="cmFSocial">
      <div class="cm-form-row"><label>${t('perfil.cumple')}</label><div class="cm-bday-selects">${bdaySelects(p.birthday)}</div></div>
      <div class="cm-form-2col"><div class="cm-form-row"><label>${t('perfil.instagram')}</label><input name="instagram" placeholder="@usuario" value="${esc(p.instagram)}"></div><div class="cm-form-row"><label>${t('perfil.tiktok')}</label><input name="tiktok" placeholder="@usuario" value="${esc(p.tiktok)}"></div></div>
      <button class="cm-btn cm-form-save" type="submit">${t('perfil.guardar')}</button><div class="cm-toast" id="cmTSocial"></div>
    </form></div>
    <a class="cm-btn cm-btn--ghost" href="/account/logout">${t('top.salir')}</a>`;
 
  function toast(el, ok) {
    el.className = 'cm-toast ' + (ok ? 'is-ok' : 'is-err');
    el.textContent = ok ? t('perfil.guardado') : t('perfil.error');
    setTimeout(() => { el.className = 'cm-toast'; }, 3000);
  }
  async function save(body, toastId) {
    try { await jpost('/api/profile', { customerId: c.id, ...body }); toast(document.getElementById(toastId), true); }
    catch { toast(document.getElementById(toastId), false); }
  }
  $('#cmFDatos').addEventListener('submit', (e) => { e.preventDefault(); const f = new FormData(e.target); save({ firstName: f.get('firstName'), lastName: f.get('lastName') }, 'cmTDatos'); });
  $('#cmFDireccion').addEventListener('submit', (e) => { e.preventDefault(); const f = new FormData(e.target); save({ address: { id: a.id, ...Object.fromEntries(f) } }, 'cmTDireccion'); });
  $('#cmFSocial').addEventListener('submit', async (e) => {
    e.preventDefault();
    const f = new FormData(e.target);
    const el = document.getElementById('cmTSocial');
    // Reconstruct birthday from three selects into YYYY-MM-DD
    const bm = f.get('bday_m'), bd2 = f.get('bday_d'), by = f.get('bday_y');
    const birthday = (bm && bd2 && by) ? `${by}-${bm}-${bd2}` : '';
    const body = { instagram: f.get('instagram'), tiktok: f.get('tiktok'), birthday };
    try {
      const res = await jpost('/api/profile', { customerId: c.id, ...body });
      el.className = 'cm-toast is-ok';
      el.textContent = res && res.birthdayBonus > 0
        ? t('perfil.bonus').replace('{n}', res.birthdayBonus)
        : t('perfil.guardado');
      setTimeout(() => { el.className = 'cm-toast'; }, 4000);
    } catch { toast(el, false); }
  });
 
  // ¿Venimos del "Agrega tu cumpleaños" en Recompensas? → llevarlo al campo
  try {
    if (sessionStorage.getItem('cm_focus_birthday') === '1') {
      sessionStorage.removeItem('cm_focus_birthday');
      const bd = panel.querySelector('select[name="bday_m"]');
      if (bd) setTimeout(() => { bd.scrollIntoView({ behavior: 'smooth', block: 'center' }); bd.focus({ preventScroll: true }); }, 350);
    }
  } catch (_) {}
}
 
// ── Montaje: tabs internas + panel ───────────────────────
const ROUTES = { inicio: renderInicio, pedidos: renderPedidos, recompensas: renderRecompensas, wishlist: renderWishlist, perfil: renderPerfil };

const shellHtml = () => `
  <div class="cm-passport-banner">
    <img src="https://cdn.shopify.com/s/files/1/0607/2175/8382/files/passport-caracas.svg?v=1783615563" alt="Caracas Passport" class="cm-passport-banner__img">
  </div>
  <div class="cm-masthead">
    <p class="cm-eyebrow">${t('inicio.titulo')}</p>
  </div>
  <nav class="cm-tabs cm-embed-tabs">
    ${Object.keys(ROUTES).map((k) => `<a class="cm-tab" href="#${k}" data-tab="${k}">${t(`tab.${k}`)}</a>`).join('')}
  </nav>
  <div id="cmPanel"></div>`;

async function mount() {
  const root = document.getElementById('cm-account-app');
  if (!root) { console.error('embed.js: falta <div id="cm-account-app"> en la página'); return; }
  rootEl = root;

  const pf = window.CM_PREFILL;

  // ── Con prefill: shell + cred card visibles al instante ──────────────
  // Liquid ya sabe quién es el cliente — no hace falta esperar el API
  // para mostrar nombre, tier y puntos. El API carga en background.
  if (pf?.firstName) {
    root.innerHTML = shellHtml().replace('<div id="cmPanel"></div>', `<div id="cmPanel">
      <h1 class="cm-hola cm-in">${esc(t('hola', { name: pf.firstName }))}</h1>
      ${pf.tier
        ? `<div class="cm-cred cm-in">
             <div class="cm-cred__row">
               <div><h2 class="cm-cred__tier">${esc(pf.tier)}</h2></div>
               ${pf.points != null
                 ? `<div class="cm-cred__points">
                      <div class="cm-cred__points-n">${pf.points}</div>
                      <div class="cm-cred__points-l">${t('cred.puntos')}</div>
                    </div>`
                 : ''}
             </div>
           </div>`
        : '<div class="cm-skel" style="height:140px"></div>'
      }
      <div class="cm-skel" style="height:160px;margin-top:1rem"></div>
    </div>`);
  } else {
    // Sin prefill: skeleton hasta que llegue el API
    root.innerHTML = '<div class="cm-skel" style="height:220px"></div>';
  }

  const me = await getMe();
  if (!me) return;

  if (!pf?.firstName) {
    root.innerHTML = shellHtml();
  }

  applyTier(me.loyalty?.tierIndex);
  const panel = $('#cmPanel', root);

  root.addEventListener('click', (e) => {
    if (e.target.closest('a[href="/account/logout"]')) bustMe();
    if (e.target.closest('[data-goto-birthday]')) {
      try { sessionStorage.setItem('cm_focus_birthday', '1'); } catch (_) {}
    }
  });

  function go(tab) {
    if (!ROUTES[tab]) tab = 'inicio';
    root.querySelectorAll('[data-tab]').forEach((a) => {
      if (a.dataset.tab === tab) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
    ROUTES[tab](panel);
  }

  root.addEventListener('click', (e) => {
    const a = e.target.closest('[data-tab]');
    if (!a) return;
    e.preventDefault();
    location.hash = a.dataset.tab;
  });
  window.addEventListener('hashchange', () => go(location.hash.slice(1)));
  go(location.hash.slice(1) || 'inicio');
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
else mount();